/* import React, { useEffect, useCallback, useState } from 'react'
import { toast } from 'react-toastify'
import { NextSeo } from 'next-seo'
import { useRouter } from 'next/router'

import { createLead } from 'services/v3'

import { sanitizeMoney } from 'helpers'

import { Text, FormIndication, Column } from '../src/components'
import { useUser } from 'context/user-context'

const CreditRequest = () => {
  const { user } = useUser()

  const router = useRouter()

  const [logged, setLogged] = useState(false)

  const onSubmit = useCallback(async data => {
    try {
      const celphone = data.celphone.replace(/\D/g, '')
      const telephone = data.telephone ? data.telephone.replace(/\D/g, '') : ''

      const body = {
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        street: data.franchise_type === 'Nova' && !data.have_cnpj ? undefined : data.street,
        number: data.franchise_type === 'Nova' && !data.have_cnpj ? undefined : data.number,
        zip_code: data.franchise_type === 'Nova' && !data.have_cnpj ? undefined : data.zip_code.replace(/\D/g, ''),
        complement: data.complement === '' ? '' : data.complement,
        city: data.franchise_type === 'Nova' && !data.have_cnpj ? undefined : data.city,
        uf: data.franchise_type === 'Nova' && !data.have_cnpj ? undefined : data.uf,
        celphone: celphone.slice(2),
        celphone_prefix: celphone.slice(0, 2),
        telephone: telephone.slice(2),
        telephone_prefix: telephone.slice(0, 2),
        cnpj:
          data.cnpj && data.franchise_type !== 'Nova' && !data.have_cnpj ? data.cnpj.replace(/[^\d]+/g, '') : undefined,
        company_name: data.company_name,
        company_site: data.company_site === '' ? '' : data.company_site,
        average_monthly_revenue: sanitizeMoney(data.average_monthly_revenue),
        desired_amount: sanitizeMoney(data.desired_amount),
        company_history: data.company_type === 'Geral' ? data.company_history : ' ',
        lending_reason: data.lending_reason,
        franchise_description: data.franchise_description === '' ? undefined : data.franchise_description,
        franchisor_name:
          data.company_type === 'Geral' ? undefined : data.franchisor ? data.first_name : data.franchisor_name,
        franchise_type:
          data.company_type === 'Geral'
            ? undefined
            : data.franchise_type === undefined
            ? undefined
            : data.franchise_type,
        franchisor: data.company_type === 'Geral' ? false : data.franchisor,
        company_type: data.company_type,
        district: 'district'
      }

      await createLead(body)
      toast.success('Solicitação de crédito realizada com sucesso!')
      router.push('/agradecemos-solicitacao')
    } catch (error) {
      if (error.response.status === 400) {
        toast.error(error.response.data.message)

        return
      }
      toast.error('Ocorreu um erro ao enviar a Solicitação de crédito')
    }
  }, [])

  useEffect(() => {
    if (!!user) {
      setLogged(true)
    }
  }, [user, setLogged])

  return (
    <Column alignItems='center' width='100%' pl='16px' pr='16px' pt={logged ? '152px' : '112px'} pb='40px'>
      <NextSeo title='Kavod Lending | Solicitação de crédito' description='KavodLending | Credit requests' />
      <Column alignItems='center'>
        <div style={{ width: '100%', maxWidth: '792px' }}>
          <Text variant='h3' mb='32px'>
            Solicitação de crédito
          </Text>
        </div>
        <FormIndication onSubmit={onSubmit} isLogged={false} />
      </Column>
    </Column>
  )
}

export default CreditRequest
 */

import { Column } from '../src/components'

const CreditRequest = () => {
  return <Column alignItems='center' width='100%' paddingTop='16vh' pl={2} pr={2} />
}

export default CreditRequest
